import { AnalyticsEvent } from "@lonelyplanet/dotcom-analytics";
import DateRange from "backpack-ui/dist/components/form/daterange";
import { Heading } from "backpack-ui/dist/components/text";
import colors from "backpack-ui/dist/styles/colors";
import * as React from "react";
import * as moment from "moment";
import DotLoader from "../../../../shared/components/dotLoader";
import Booking from "./booking";
var BookingLodging = function (_a) {
    var dates = _a.dates, focusedInput = _a.focusedInput, handleDateChange = _a.handleDateChange, handleFocusChange = _a.handleFocusChange, loading = _a.loading, price = _a.price, nights = _a.nights, url = _a.url, provider = _a.provider, rating = _a.rating, unavailable = _a.unavailable;
    return (React.createElement(Booking, null,
        price ?
            React.createElement(Booking.Price, { labelAfter: nights + " night" + (nights !== 1 ? "s" : "") }, price)
            :
                React.createElement("div", null, loading && React.createElement(DotLoader, { inline: true }) || React.createElement(Heading, { level: 4, size: 7, weight: "regular" }, "Check Availability")),
        unavailable &&
            React.createElement("div", null,
                React.createElement(Heading, { level: 4, size: 8, weight: "medium", style: { color: colors.accentRed } }, "Unavailable at these dates.")),
        React.createElement(DateRange, { id: "lodging-date-range", numberOfMonths: 1, startDatePlaceholderText: "Check-in", endDatePlaceholderText: "Check-out", soldOut: unavailable, startDate: dates && dates.startDate, endDate: dates && dates.endDate, onDatesChange: handleDateChange, onFocusChange: handleFocusChange, focusedInput: focusedInput, lastSelectableDate: moment().add(16, "months") }),
        url &&
            React.createElement(AnalyticsEvent, { render: function (track) { return (React.createElement(Booking.Button, { href: url, onClick: function () {
                        track({
                            bookingProvider: provider,
                            event: "lodging booking click",
                            "gtm.element": "Booking.Button",
                            "gtm.elementText": "Select your room",
                        });
                    } }, "Select your room")); } }),
        rating &&
            React.createElement(Booking.Rating, null, rating),
        React.createElement(Booking.Provider, { provider: provider })));
};
export default BookingLodging;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/booking/bookingLodging.tsx
// module id = JDoo
// module chunks = 2